export default {
  'title': 'Ma liste de courses',
  'seo': {
    title: 'Liste de courses intelligente en ligne - Mon Marché',
    description:
      'Gagnez du temps en construisant votre liste de courses parmi nos produits soigneusement sélectionnés. Fraîcheur et simplicité au rendez-vous.',
  },
  'nb-products-in-cart': {
    default: '%{done} / %{count} produit',
    default_plural: '%{done} / %{count} produits',
    completed: '%{done} / %{count} produit 🎉',
    completed_plural: '%{done} / %{count} produits 🎉',
  },
  'placeholder': {
    'add-product': 'Ajouter un produit',
    'edit-product': 'Modifier un produit',
  },
  'button': {
    'add-product': 'Ajouter',
    'finish': 'Terminer',
  },
  'empty-results': 'Aucun résultat pour %{term}',
  'update-search': 'Modifier la recherche',
  'dialog': {
    'not-complete': {
      title: 'Quitter la liste de course',
      description:
        'Vous n’avez pas encore ajouté tous les produits de votre liste.<br><br> Êtes-vous sûr de vouloir la quitter ?',
      cancel: 'Continuer',
      confirm: 'Quitter la liste',
    },
    'complete': {
      title: 'Liste de course ✅',
      description:
        'Votre panier se remplit. Complétez-le avec les nouveautés ou les promotions du moment.',
      cancel: 'Voir les Promotions',
      confirm: 'Voir les Nouveautés',
    },
  },
  'no-terms': {
    description:
      'Votre liste est vide.<br>Cliquez sur le bouton en dessous pour commencer à la remplir',
    button: 'Faire ma liste de courses',
  },
};
